module.exports = __webpack_public_path__ + "img/gold4.dcd3682b.png";